const providers = new Map();

export function createEmptyHelpDocument(namespace = "", helpKey = "") {
  const identity = [namespace, helpKey].filter(Boolean).join("/") || "unknown";
  return {
    name: "页面操作",
    summary: "当前页面的操作说明尚未配置。",
    flow: [],
    steps: [
      {
        title: "联系管理员",
        content: `请提供帮助标识“${identity}”，由对应业务模块补充操作文档。`
      }
    ],
    sections: [],
    reminders: []
  };
}

/**
 * 注册业务模块自己的帮助文档解析器。
 * resolver 接收 (helpKey, context)，返回统一帮助文档对象。
 */
export function registerHelpProvider(namespace, resolver) {
  if (!namespace || typeof resolver !== "function") {
    throw new Error("registerHelpProvider requires a namespace and resolver function");
  }
  providers.set(namespace, resolver);
}

export function unregisterHelpProvider(namespace) {
  providers.delete(namespace);
}

export function resolveHelpDocument(namespace, helpKey, context = {}) {
  const resolver = providers.get(namespace);
  if (!resolver) return createEmptyHelpDocument(namespace, helpKey);
  return resolver(helpKey, context) || createEmptyHelpDocument(namespace, helpKey);
}
